/* ===== PALAS COUNTRY SELECTOR =====
   Bottom-sheet on mobile, centered modal on desktop.
   Live search filter, popular countries section, body scroll lock.
   Submits the wrapping {%- form 'localization' -%} to switch country. */
(function () {
  'use strict';

  var SEL = {
    picker: '[data-palas-country-picker]',
    toggle: '[data-palas-country-toggle]',
    modal: '[data-palas-country-modal]',
    close: '[data-palas-country-close]',
    search: '[data-palas-country-search]',
    option: '[data-palas-country-option]',
    optionWrapper: '[data-palas-country-name]',
    input: '[data-palas-country-input]',
    noResults: '[data-palas-country-no-results]'
  };

  function PalasCountryPicker(picker) {
    this.picker = picker;
    this.toggle = picker.querySelector(SEL.toggle);
    this.modal = picker.querySelector(SEL.modal);
    this.search = picker.querySelector(SEL.search);
    this.input = picker.querySelector(SEL.input);
    this.noResults = picker.querySelector(SEL.noResults);
    this.options = picker.querySelectorAll(SEL.optionWrapper);
    this.form = picker.closest('form');
    this._onKeyDown = this._onKeyDown.bind(this);

    if (!this.toggle || !this.modal || !this.form) return;
    this._bindEvents();
  }

  PalasCountryPicker.prototype._bindEvents = function () {
    var self = this;

    this.toggle.addEventListener('click', function (e) {
      e.preventDefault();
      self.open();
    });

    Array.prototype.forEach.call(
      this.modal.querySelectorAll(SEL.close),
      function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          self.close();
        });
      }
    );

    Array.prototype.forEach.call(
      this.modal.querySelectorAll(SEL.option),
      function (option) {
        option.addEventListener('click', function (e) {
          e.preventDefault();
          var code = option.getAttribute('data-value');
          if (!code) return;
          self.input.value = code;
          self.form.submit();
        });
      }
    );

    if (this.search) {
      this.search.addEventListener('input', function (e) {
        self._filter(e.target.value);
      });
    }
  };

  PalasCountryPicker.prototype._onKeyDown = function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      this.close();
    }
  };

  PalasCountryPicker.prototype.open = function () {
    this.modal.removeAttribute('hidden');
    this.toggle.setAttribute('aria-expanded', 'true');
    document.body.classList.add('palas-country-picker-open');
    document.addEventListener('keydown', this._onKeyDown);

    var self = this;
    var isDesktop = window.matchMedia && window.matchMedia('(min-width: 750px)').matches;
    if (this.search && isDesktop) {
      setTimeout(function () { self.search.focus(); }, 200);
    }
  };

  PalasCountryPicker.prototype.close = function () {
    this.modal.setAttribute('hidden', '');
    this.toggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('palas-country-picker-open');
    document.removeEventListener('keydown', this._onKeyDown);
    if (this.search) {
      this.search.value = '';
      this._filter('');
    }
    this.toggle.focus();
  };

  PalasCountryPicker.prototype._filter = function (query) {
    var q = (query || '').toLowerCase().trim();
    var hasMatch = false;

    if (q === '') {
      this.picker.removeAttribute('data-palas-searching');
      Array.prototype.forEach.call(this.options, function (opt) {
        opt.removeAttribute('hidden');
      });
      if (this.noResults) this.noResults.setAttribute('hidden', '');
      return;
    }

    this.picker.setAttribute('data-palas-searching', '');

    Array.prototype.forEach.call(this.options, function (opt) {
      var name = opt.getAttribute('data-palas-country-name') || '';
      var code = opt.getAttribute('data-palas-country-code') || '';
      var match = name.indexOf(q) !== -1 || code.indexOf(q) !== -1;
      if (match) {
        opt.removeAttribute('hidden');
        hasMatch = true;
      } else {
        opt.setAttribute('hidden', '');
      }
    });

    if (this.noResults) {
      if (hasMatch) {
        this.noResults.setAttribute('hidden', '');
      } else {
        this.noResults.removeAttribute('hidden');
      }
    }
  };

  function init() {
    var pickers = document.querySelectorAll(SEL.picker);
    Array.prototype.forEach.call(pickers, function (picker) {
      if (picker.dataset.palasCountryInit === 'true') return;
      new PalasCountryPicker(picker);
      picker.dataset.palasCountryInit = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
